import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Api from "services/api";

export const initialState = {
  allTranslators: [],
  interpretersWithTranslations: [],
  invitedTranslators: [],
  inviteTranslators: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  dynamicFields: [],
  analytics: [],
  appointment: [],
};

export const inviteTranslatorsSlice = createSlice({
  name: "inviteTranslators",
  initialState: initialState,
  reducers: {
    setInviteTranslator: (state, { payload }) => {
      state.inviteTranslators = payload?.data ?? payload;
      state.total = payload?.data?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.data?.last_page;
    },
    setInviteTranslators: (state, { payload }) => {
      state.inviteTranslators = payload?.data;
      state.total = payload?.data?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.data?.last_page;
    },
    setAllTranslators: (state, { payload }) => {
      state.allTranslators = payload?.data;
    },
    setTranslation: (state, { payload }) => {
      state.appointment = payload?.data?.invites;
    },
    setTranslatorsWithTranslations: (state, { payload }) => {
      state.interpretersWithTranslations = payload?.data;
    },
    setInvitedTranslators: (state, { payload }) => {
      state.invitedTranslators = payload?.data;
    },
    setDynamicFields: (state, { payload }) => {
      state.dynamicFields = payload?.data;
    },

    setMoreInviteTranslators: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
    },
    removeInviteTranslator: (state, { payload }) => {
      state.error = payload;
    },
    clearAllInviteTranslator: (state, { payload }) => {
      state.loader = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
  },
});

export const addInviteTranslator = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.addInviteTranslator(data);
    if (json.status >= 200 && json.status < 300) {
      console.log(json);
      // dispatch(setInviteTranslator(json.data))
      callback(true, json.data.message);
    } else if (json.status == 422) {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
    // callback(false)
  }
  dispatch(setLoader(false));
};

export const updateInviteTranslator =
  (data, itemId, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}));
    dispatch(setLoader(true));
    try {
      const json = await Api.updateInviteTranslator(data, itemId);
      if (json.status >= 200 && json.status < 300) {
        console.log(json);
        // dispatch(setInviteTranslator(json.data))
        callback(true, json.data.message);
      } else if (json.status == 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
      }
    } catch (error) {
      console.log(error);
      // callback(false)
    }
    dispatch(setLoader(false));
  };

export const removeInviteTranslator =
  (itemId, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}));
    dispatch(setLoader(true));
    try {
      const json = await Api.removeInviteTranslator(itemId);
      if (json.status >= 200 && json.status < 300) {
        console.log(json);
        // dispatch(setInviteTranslator(json.data))
        callback(true, json.data.message);
      } else if (json.status == 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
      }
    } catch (error) {
      console.log(error);
      // callback(false)
    }
    dispatch(setLoader(false));
  };

export const fetchInviteTranslators =
  (page, params, disableLoader) => async (dispatch) => {
    const apiService = new Api();
    !disableLoader && dispatch(setLoader(true));
    try {
      const result = await Api.fetchInviteTranslators(page, params);
      if (result.status >= 200 && result.status < 300) {
        if (page > 1) {
          dispatch(setInviteTranslators(result.data.data));
        } else {
          dispatch(setInviteTranslators(result.data.data));
        }
      } else if (result?.status == 422) {
        dispatch(setError(result.data));
      }
    } catch (error) {
      console.log("error", error);
    }
    !disableLoader && dispatch(setLoader(false));
  };
export const fetchTranslators = (id, params = {}) => async (dispatch) => {
  const apiService = new Api();
  try {
    const result = await Api.getTranslators(id, params);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setAllTranslators(result.data));
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
    }
  } catch (error) {
    console.log("error", error);
  }
};

export const fetchTranslatorsWithTranslations = (id) => async (dispatch) => {
  const apiService = new Api();
  try {
    const result = await Api.fetchTranslatorsWithTranslations(id);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setTranslatorsWithTranslations(result.data));
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
    }
  } catch (error) {
    console.log("error", error);
  }
};
export const fetchInvitedTranslators = (id) => async (dispatch) => {
  const apiService = new Api();
  try {
    const result = await Api.getInvitedTranslators(id);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setInvitedTranslators(result.data));
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
    }
  } catch (error) {
    console.log("error", error);
  }
};

export const removeInvitedTranslators =
  (ids, itemId, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}));
    dispatch(setLoader(true));
    try {
      const json = await Api.removeInvitedTranslators(itemId, ids);
      if (json.status >= 200 && json.status < 300) {
        console.log(json);
        // dispatch(setHospital(json.data))
        callback(true, json.data.message);
      } else if (json.status == 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
      }
    } catch (error) {
      console.log(error);
      // callback(false)
    }
    dispatch(setLoader(false));
  };
export const addInviteTranslators =
  (ids, itemId, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}));
    dispatch(setLoader(true));
    try {
      const json = await Api.inviteTranslators(itemId, ids);
      if (json.status >= 200 && json.status < 300) {
        console.log(json);
        // dispatch(setHospital(json.data))
        callback(true, json.data.message);
        dispatch(setLoader(false));
      } else if (json.status == 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
        dispatch(setLoader(false));
      }
    } catch (error) {
      console.log(error);
      callback(false);
      dispatch(setLoader(false));
    }
  };

export const assignTranslators =
  (ids, itemId, callback) => async (dispatch) => {
    const apiService = new Api();
    dispatch(setError({}));
    dispatch(setLoader(true));
    try {
      const json = await Api.assignTranslators(itemId, ids);
      if (json.status >= 200 && json.status < 300) {
        console.log(json);
        // dispatch(setHospital(json.data))
        callback(true, json.data.message);
        dispatch(setLoader(false));
      } else if (json.status == 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
        dispatch(setLoader(false));
      }
    } catch (error) {
      console.log(error);
      callback(false);
      dispatch(setLoader(false));
    }
  };

export const translationApproveSubmission =
  (itemId, callback) => async (dispatch) => {
    new Api();
    dispatch(setError({}));
    dispatch(setLoader(true));
    try {
      const json = await Api.translationApproveSubmission(itemId);
      if (json.status >= 200 && json.status < 300) {
        console.log(json);
        // dispatch(setHospital(json.data))
        callback(true, json.data.message);
        dispatch(setLoader(false));
      } else if (json.status == 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
        dispatch(setLoader(false));
      }
    } catch (error) {
      console.log(error);
      callback(false);
      dispatch(setLoader(false));
    }
  };

export const translationMarkInvoiceAsPaid =
  (itemId, callback) => async (dispatch) => {
    new Api();
    dispatch(setError({}));
    dispatch(setLoader(true));
    try {
      const json = await Api.translationMarkInvoiceAsPaid(itemId);
      if (json.status >= 200 && json.status < 300) {
        console.log(json);
        // dispatch(setHospital(json.data))
        callback(true, json.data.message);
        dispatch(setLoader(false));
      } else if (json.status == 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
        dispatch(setLoader(false));
      }
    } catch (error) {
      console.log(error);
      callback(false);
      dispatch(setLoader(false));
    }
  };
export const translationCancel =
  (data, itemId, callback) => async (dispatch) => {
    new Api();
    dispatch(setError({}));
    dispatch(setLoader(true));
    try {
      const json = await Api.translationCancel(itemId, data);
      if (json.status >= 200 && json.status < 300) {
        console.log(json);
        // dispatch(setHospital(json.data))
        callback(true, json.data.message);
        dispatch(setLoader(false));
      } else if (json.status == 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
        dispatch(setLoader(false));
      }
    } catch (error) {
      console.log(error);
      callback(false);
      dispatch(setLoader(false));
    }
  };
export const translationUploadDocument =
  (data, itemId, callback) => async (dispatch) => {
    new Api();
    dispatch(setError({}));
    dispatch(setLoader(true));
    try {
      const json = await Api.translationUploadDocument(itemId, data);
      if (json.status >= 200 && json.status < 300) {
        console.log(json);
        // dispatch(setHospital(json.data))
        callback(true, json.data.message);
        dispatch(setLoader(false));
      } else if (json.status == 422) {
        dispatch(setError(json.data));
        callback(false, json.data.message);
        dispatch(setLoader(false));
      }
    } catch (error) {
      console.log(error);
      callback(false);
      dispatch(setLoader(false));
    }
  };

export const fetchTranslationView = (id) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const result = await Api.fetchClientTranslationView(id);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setTranslation(result?.data));
      dispatch(setLoader(false));
    } else if (result?.status == 422) {
      dispatch(setError(result.data));
      dispatch(setLoader(false));
      // callback&&callback(false, result?.data?.message)
    }
  } catch (error) {
    console.log("error", error);
    dispatch(setLoader(false));
    // callback&&callback(false, error?.data?.message)
  }
};

export const {
  setInviteTranslator,
  setTranslatorsWithTranslations,
  setInviteTranslators,
  setAllTranslators,
  clearAllInviteTranslator,
  setLoader,
  setError,
  setMoreInviteTranslators,
  setDynamicFields,
  setTranslation,
  setInvitedTranslators,
} = inviteTranslatorsSlice.actions;

export default inviteTranslatorsSlice.reducer;
export const inviteTranslatorsSelector = (state) => state.inviteTranslators;
